export default "__VITE_ASSET__CvNhX9SC__"